import axios from "axios";
import {
    OUR_TEAM_LIST_REQUEST, OUR_TEAM_LIST_SUCCESS, OUR_TEAM_LIST_FAIL,
    OUR_TEAM_DETAILS_REQUEST, OUR_TEAM_DETAILS_SUCCESS, OUR_TEAM_DETAILS_FAIL,
} from "../constants/categoryConstants";
import { BASE_URL, OURTEAM_URL, OURTEAM_DETAIL_URL } from "../api";


export const listOurTeam = () => async (dispatch) => {
  try {
    dispatch({ type: OUR_TEAM_LIST_REQUEST });
    const { data } = await axios.get(BASE_URL+OURTEAM_URL);
    dispatch({
      type: OUR_TEAM_LIST_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: OUR_TEAM_LIST_FAIL,
      
      payload:
        error.response && error.response.data.detail
          ? error.response.data.detail
          : error.message,
    });
  }
};



export const listOurTeamDetails =(id) => async (dispatch)=>{

  try{
      dispatch({type:OUR_TEAM_DETAILS_REQUEST}) 
      const {data} = await axios.get(BASE_URL+OURTEAM_DETAIL_URL+ `${id}` + '/')

      dispatch({
          type:OUR_TEAM_DETAILS_SUCCESS,
          payload:data
      })

  }
  catch(error){
      dispatch({
          type:OUR_TEAM_DETAILS_FAIL,
          payload:error.response && error.response.data.detail
          ? error.response.data.detail
          :error.message,
      })

  }
}